import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./yvola/AuthContext";
import Layout from "./yvola/Layout";
import Login from "./yvola/pages/Login";
import Signup from "./yvola/pages/Signup";
import Activate from "./yvola/pages/Activate";
import ResetPassword from "./yvola/pages/ResetPassword";
import ActivareCampanie from "./yvola/pages/ActivareCampanie";
import ActivareDistribuitor from "./yvola/pages/ActivareDistribuitor";
import Dashboard from "./yvola/pages/Dashboard";
import Contacts from "./yvola/pages/Contacts";
import Templates from "./yvola/pages/Templates";
import Campaigns from "./yvola/pages/Campaigns";
import CampaignDetail from "./yvola/pages/CampaignDetail";
import Billing from "./yvola/pages/Billing";
import Tenants from "./yvola/pages/Tenants";
import Site from "./yvola/pages/Site";
import ComplexApp from "./yvola/pages/ComplexApp";
import PublicSite from "./yvola/pages/PublicSite";
import Home from "./yvola/pages/Home";
import LeadOrders from "./yvola/pages/LeadOrders";
import ErpYvola from "./yvola/pages/ErpYvola";
import CompanyProfile from "./yvola/pages/CompanyProfile";
import ProformeEmise from "./yvola/pages/ProformeEmise";
import Crm from "./yvola/pages/Crm";
import TenantCrm from "./yvola/pages/TenantCrm";
import Campanii from "./yvola/pages/Campanii";
import RapoarteCampanii from "./yvola/pages/RapoarteCampanii";
import CampaniiTenant from "./yvola/pages/CampaniiTenant";
import CampaniiTenanti from "./yvola/pages/CampaniiTenanti";
import Configurator from "./yvola/pages/Configurator";
import Utilizatori from "./yvola/pages/Utilizatori";
import { Loader2 } from "lucide-react";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="w-6 h-6 animate-spin text-emerald-600" /></div>;
  if (!user) return <Navigate to="/home" replace />;
  return children;
}

function landingPath(u) {
  return u && u.role !== "super_admin" && u.tenant_slug ? `/site/${u.tenant_slug}` : "/";
}

function AppRoutes() {
  const { user, isSuperAdmin } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to={landingPath(user)} replace /> : <Login />} />
      <Route path="/signup" element={user ? <Navigate to={landingPath(user)} replace /> : <Signup />} />
      <Route path="/activate" element={<Activate />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/activare" element={<ActivareCampanie />} />
      <Route path="/distribuitor" element={<ActivareDistribuitor />} />
      <Route path="/home" element={<Home />} />
      <Route path="/site/:slug" element={<PublicSite />} />
      <Route element={<Protected><Layout /></Protected>}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/contacts" element={<Contacts />} />
        <Route path="/templates" element={<Templates />} />
        <Route path="/campaigns" element={<Campaigns />} />
        <Route path="/campaigns/:id" element={<CampaignDetail />} />
        <Route path="/billing" element={<Billing />} />
        <Route path="/site" element={<Site />} />
        <Route path="/complex-app" element={<ComplexApp />} />
        <Route path="/lead-orders" element={isSuperAdmin ? <LeadOrders /> : <Navigate to="/" replace />} />
        <Route path="/erp-yvola" element={<ErpYvola />} />
        <Route path="/company-profile" element={<CompanyProfile />} />
        <Route path="/proforme" element={<ProformeEmise />} />
        <Route path="/configurator" element={<Configurator />} />
        <Route path="/utilizatori" element={<Utilizatori />} />
        <Route path="/tenants" element={<Tenants />} />
        <Route path="/crm" element={<Crm />} />
        <Route path="/tenant-crm" element={<TenantCrm />} />
        <Route path="/campanii" element={<Campanii />} />
        <Route path="/campanii-tenanti" element={isSuperAdmin ? <CampaniiTenanti /> : <Navigate to="/" replace />} />
        <Route path="/rapoarte-campanii" element={isSuperAdmin ? <RapoarteCampanii /> : <Navigate to="/" replace />} />
        <Route path="/campanii-tenant" element={isSuperAdmin ? <CampaniiTenant /> : <Navigate to="/" replace />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}
